import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsCustomEventPropertySchemaCacheKeys: AllRouteEndpoints[] = [];
